import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ onlyUsagePricing: boolean }>()(
  (theme: Theme, { onlyUsagePricing }) => ({
    sectionText: {
      fontSize: '12px !important',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px !important',
      letterSpacing: '0.25px',
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
      textAlign: 'left',
    },
    sectionContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(3),
      width: '100%',
    },
    root: {
      width: '100%',
      boxSizing: 'border-box',
    },
    elementsGap: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    titleWraper: {
      display: 'flex',
      gap: theme.spacing(4),
    },
    border: {
      borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
      width: '100%',
      borderRadius: theme.spacing(0.5),
      boxSizing: 'border-box',
    },
    resourceRow: {
      display: 'flex',
      justifyContent: 'flex-start',
      gap: theme.spacing(4),
      width: '100%',
    },
    resourcesContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      gap: theme.spacing(4),
      width: '100%',
    },
    alignDescription: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      color: theme.palette.textField.dark,
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
    },
    columnContent: {
      width: onlyUsagePricing ? '39.5%' : '42%',
    },
    columnItems: {
      width: '42%',
    },
    indexColumn: {
      width: theme.spacing(3),
      alignSelf: 'center',
      textAlign: 'center',
      color: theme.palette.textField.dark,
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
    },
    totalCount: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '0.25px',
      color: theme.palette.labraText.description,
      fontFamily: theme.typography.fontFamily,
    },
    instancesContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    instanceItem: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    fieldWidth: {
      maxWidth: theme.spacing(26.25),
      width: '100%',
    },
    scrollableContainer: {
      maxHeight: theme.spacing(90.25),
      overflowY: 'auto',
      paddingTop: theme.spacing(2),
      marginTop: theme.spacing(-2),
      paddingRight: theme.spacing(2),
      marginRight: theme.spacing(-2),
      overflowX: 'hidden',
      // Webkit browsers (Chrome, Safari, Edge)
      '&::-webkit-scrollbar': {
        width: theme.spacing(1),
        height: theme.spacing(1),
        WebkitAppearance: 'none',
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
        borderRadius: theme.spacing(0.5),
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.select.hover,
        borderRadius: theme.spacing(0.5),
        minHeight: theme.spacing(6.75),
      },
      // Firefox
      scrollbarWidth: 'thin',
      scrollbarColor: `${theme.palette.select.hover} transparent`,
    },
  })
)
